import {password} from "@/lib/baseConfig";

export function makeHeaderSign(data) {
  const sign = hex_md5(hex_md5(password) + JSON.stringify(data));
  return sign;
}



// WEBPACK FOOTER //
// ./src/utils/makeHeaderSign.js